/**
 * Azure AD Authentication Service
 * Leverages Azure Static Web Apps built-in authentication
 */

import axios from 'axios';
import { ClientPrincipal, Tutor } from './types';

/**
 * Get current authenticated user from /.auth/me endpoint
 */
export async function getAuthUser(): Promise<ClientPrincipal | null> {
  try {
    const response = await axios.get<{ clientPrincipal: ClientPrincipal | null }>('/.auth/me');
    return response.data.clientPrincipal;
  } catch (error) {
    console.error('Failed to fetch auth user:', error);
    return null;
  }
}

/**
 * Check if user is authenticated
 */
export async function isAuthenticated(): Promise<boolean> {
  const user = await getAuthUser();
  return user !== null;
}

/**
 * Get tutor profile with role information
 * This calls the API which checks CosmosDB tutors container
 */
export async function getTutorProfile(): Promise<Tutor | null> {
  try {
    const response = await axios.get<{ success: boolean; data?: Tutor; error?: string }>('/api/auth/profile');
    if (response.data.success && response.data.data) {
      return response.data.data;
    }
    return null;
  } catch (error) {
    console.error('Failed to fetch tutor profile:', error);
    return null;
  }
}

/**
 * Redirect to Azure AD login
 */
export function login(): void {
  window.location.href = '/login';
}

/**
 * Logout user
 */
export function logout(): void {
  window.location.href = '/logout';
}

/**
 * Check if user has required role (client-side check)
 * Note: Server-side validation is still enforced by API
 */
export function hasRole(userRole: string, requiredRole: string): boolean {
  const roles: Record<string, number> = {
    viewer: 1,
    operator: 2,
    admin: 3,
  };

  return (roles[userRole] || 0) >= (roles[requiredRole] || 0);
}
